import { render, staticRenderFns } from "./ListDataCenter.vue?vue&type=template&id=2af5bfe4&lang=pug"
import script from "./ListDataCenter.vue?vue&type=script&lang=js"
export * from "./ListDataCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2af5bfe4')) {
      api.createRecord('2af5bfe4', component.options)
    } else {
      api.reload('2af5bfe4', component.options)
    }
    module.hot.accept("./ListDataCenter.vue?vue&type=template&id=2af5bfe4&lang=pug", function () {
      api.rerender('2af5bfe4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/chatbots/modules/datacenter/ListDataCenter.vue"
export default component.exports